import { cn } from "@/lib/utils"

export function ProfileListCardSkeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "bg-white border border-gray-200 rounded-2xl shadow-soft-md overflow-hidden animate-pulse",
        className
      )}
      role="status"
      aria-label="Loading profile"
    >
      <div className="flex flex-col sm:flex-row gap-6 p-8">
        {/* Profile Photo Skeleton - Left Side */}
        <div className="flex-shrink-0">
          <div className="w-32 h-32 sm:w-40 sm:h-40 bg-gray-200 rounded-xl" />
        </div>

        {/* Content Skeleton - Right Side */}
        <div className="flex-1 min-w-0">
          {/* Name and Title */}
          <div className="mb-3">
            <div className="h-7 bg-gray-200 rounded w-48 mb-2" />
            <div className="h-6 bg-gray-200 rounded w-64" />
          </div>

          {/* Quick Stats Bar */}
          <div className="flex flex-wrap gap-4 sm:gap-5 mb-5">
            <div className="h-5 bg-gray-200 rounded w-32" />
            <div className="h-5 bg-gray-200 rounded w-36" />
            <div className="h-5 bg-gray-200 rounded w-28" />
            <div className="h-5 bg-gray-200 rounded w-32" />
          </div>

          {/* Bio Lines */}
          <div className="mb-5 space-y-2">
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-4 bg-gray-200 rounded w-3/4" />
          </div>

          {/* Sector Tags */}
          <div className="flex flex-wrap gap-2 mb-4">
            <div className="h-7 bg-gray-200 rounded-full w-24" />
            <div className="h-7 bg-gray-200 rounded-full w-32" />
            <div className="h-7 bg-gray-200 rounded-full w-28" />
            <div className="h-7 bg-gray-200 rounded-full w-20" />
          </div>

          {/* Action Buttons */}
          <div className="flex flex-wrap gap-3 mt-5">
            <div className="h-10 bg-gray-200 rounded-full w-36" />
            <div className="h-10 bg-gray-200 rounded-full w-36" />
          </div>
        </div>
      </div>
    </div>
  )
}

export function ProfileGridCardSkeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden flex flex-col h-full animate-pulse",
        className
      )}
      role="status"
      aria-label="Loading profile"
    >
      {/* Profile Photo Skeleton */}
      <div className="aspect-square sm:aspect-[5/6] md:aspect-[4/5] w-full bg-gray-200" />

      {/* Content Skeleton */}
      <div className="p-4 sm:p-5 md:p-6 text-center flex flex-col flex-1">
        {/* Name */}
        <div className="h-6 bg-gray-200 rounded w-3/4 mx-auto mb-3" />

        {/* Bio/Title */}
        <div className="mt-2 sm:mt-3 flex-1 flex items-start">
          <div className="space-y-2 w-full">
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-4 bg-gray-200 rounded w-5/6 mx-auto" />
          </div>
        </div>

        {/* Button */}
        <div className="mt-3 sm:mt-4">
          <div className="h-9 bg-gray-200 rounded-full w-full" />
        </div>
      </div>
    </div>
  )
}
